export default "__VITE_ASSET__DNz74DRl__"